var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { defaultViewSizes } from './types';
import { useMediaQueries } from './use-media-queries';
import { convertToUseBaseFontSizePx, getViewSizeFromDeviceInformation } from './view-size-utils';
/**
 * The defaults will be used if the `<ViewportProvider>` is not used by the client.
 */
var defaults = {
    viewSizes: defaultViewSizes,
    validViewSize: defaultViewSizes.SMALL,
    setValidViewSize: function (size) { return 0; }
};
export var ViewportContext = React.createContext(defaults);
/**
 * This component is meant to be a top-level component to provide ViewportContext
 * to its consumers
 * @returns A `<ViewportContext.Provider>`
 */
var ViewportProvider = function (props) {
    var viewSizes = props.viewSizes, baseFontSizePx = props.baseFontSizePx, deviceInformation = props.deviceInformation, children = props.children;
    var validatedViewSizes = viewSizes || defaultViewSizes;
    if (baseFontSizePx) {
        validatedViewSizes = convertToUseBaseFontSizePx(validatedViewSizes, baseFontSizePx);
    }
    // set initial view size from DeviceInformation
    var deviceViewSize;
    if (deviceInformation) {
        deviceViewSize = getViewSizeFromDeviceInformation(validatedViewSizes, deviceInformation, baseFontSizePx);
    }
    var _a = __read(React.useState(deviceViewSize || defaults.validViewSize), 2), viewSize = _a[0], setViewSize = _a[1];
    var validViewSize = useMediaQueries({
        viewSizes: validatedViewSizes,
        deviceInformation: deviceInformation,
        baseFontSizePx: baseFontSizePx
    });
    React.useEffect(function () {
        setViewSize(validViewSize);
    }, [validViewSize]);
    var viewportContext = {
        baseFontSizePx: baseFontSizePx,
        validViewSize: viewSize,
        setValidViewSize: setViewSize,
        viewSizes: validatedViewSizes
    };
    return React.createElement(ViewportContext.Provider, { value: viewportContext }, children);
};
/**
 * This hook use called by the `<Viewport>` and `<MaxViewport>` components to retrieve the `ViewportContext`.
 */
export var useViewport = function () { return React.useContext(ViewportContext); };
export default ViewportProvider;
//# sourceMappingURL=viewport-provider.js.map